module.exports = __webpack_public_path__ + "img/entities.88d1acd7.svg";